let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kzDMQ")).then(() => parcelRequire('drGkM'));